import React from 'react';
import {
  Document, Page, Text, View,
  StyleSheet, PDFDownloadLink
} from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 11,
    fontFamily: 'Helvetica',
    color: '#1a1a1a',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 32,
  },
  shopName: { fontSize: 18, fontFamily: 'Helvetica-Bold' },
  shopInfo: { fontSize: 10, color: '#666', marginTop: 4, lineHeight: 1.5 },
  invoiceTitle: {
    fontSize: 16,
    fontFamily: 'Helvetica-Bold',
    textAlign: 'right',
  },
  invoiceNum: { fontSize: 11, color: '#666', textAlign: 'right', marginTop: 4 },
  badge: {
    marginTop: 8,
    alignSelf: 'flex-end',
    backgroundColor: '#d1fae5',
    color: '#065f46',
    fontSize: 10,
    padding: '3 10',
    borderRadius: 4,
  },
  metaRow: {
    flexDirection: 'row',
    gap: 12,
    marginBottom: 24,
  },
  metaBox: {
    flex: 1,
    backgroundColor: '#f5f5f5',
    borderRadius: 6,
    padding: 10,
  },
  metaLabel: { fontSize: 9, color: '#888', marginBottom: 3 },
  metaValue: { fontSize: 9, fontFamily: 'Helvetica-Bold' },
  tableHeader: {
    flexDirection: 'row',
    borderBottomWidth: 0.5,
    borderBottomColor: '#ddd',
    paddingBottom: 6,
    marginBottom: 4,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 0.5,
    borderBottomColor: '#eee',
    paddingVertical: 8,
  },
  colProduct: { flex: 3 },
  colQty: { flex: 1, textAlign: 'center' },
  colPrice: { flex: 1.5, textAlign: 'right' },
  colTotal: { flex: 1.5, textAlign: 'right' },
  headerText: { fontSize: 9, color: '#888', fontFamily: 'Helvetica-Bold' },
  productName: { fontFamily: 'Helvetica-Bold' },
  productVariant: { fontSize: 9, color: '#888', marginTop: 2 },
  totalSection: { alignItems: 'flex-end', marginTop: 16 },
  totalRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: 220,
    paddingVertical: 3,
  },
  totalLabel: { color: '#666' },
  totalLine: {
    borderTopWidth: 0.5,
    borderTopColor: '#ddd',
    marginTop: 4,
    paddingTop: 8,
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: 220,
  },
  totalBold: { fontFamily: 'Helvetica-Bold', fontSize: 13 },
  footer: {
    marginTop: 40,
    borderTopWidth: 0.5,
    borderTopColor: '#eee',
    paddingTop: 16,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  footerText: { fontSize: 10, color: '#888' },
});


export default function InvoiceDocument({invoice}) {
  const subtotal = 0;
  const vat = subtotal * invoice.vatRate;
  const total = 0;
  console.log(invoice);

  return (
    <Document>
      <Page size="A4" style={styles.page}>

        {/* En-tête */}
        <View style={styles.header}>
          <View>
            <Text style={styles.shopName}>Djamnazi</Text>
            <Text style={styles.shopInfo}>
              Moroni Magoudjou{'\n'}
              djamnazi@always-data.fr
            </Text>
          </View>
          <View>
            <Text style={styles.invoiceTitle}>Facture</Text>
            <Text style={styles.invoiceNum}>#{invoice.number}</Text>
            <Text style={styles.badge}>{invoice.status}</Text>
          </View>
        </View>

        {/* Infos clés */}
        <View style={styles.metaRow}>
          {[
            { label: 'Date de paiement', value: invoice.date },
            { label: 'Contact', value: invoice.contact },
            { label: 'Mode de paiement', value: invoice.payment },
          ].map((m, i) => (
            <View key={i} style={styles.metaBox}>
              <Text style={styles.metaLabel}>{m.label}</Text>
              <Text style={styles.metaValue}>{m.value}</Text>
            </View>
          ))}
        </View>

        {/* Tableau articles */}
        <View style={styles.tableHeader}>
          <Text style={[styles.headerText, styles.colProduct]}>PRODUIT</Text>
          <Text style={[styles.headerText, styles.colQty]}>QTÉ</Text>
          <Text style={[styles.headerText, styles.colPrice]}>PRIX UNIT.</Text>
          <Text style={[styles.headerText, styles.colTotal]}>TOTAL</Text>
        </View>

        {invoice.items.map((item, i) => (
          <View key={i} style={styles.tableRow}>
            <View style={styles.colProduct}>
              <Text style={styles.productName}>{item.name}</Text>
              <Text style={styles.productVariant}>{item.variant}</Text>
            </View>
            <Text style={styles.colQty}>{item.qty}</Text>
            <Text style={styles.colPrice}>{item.price} €</Text>
            <Text style={styles.colTotal}>{(item.qty * Number(item.price)).toFixed(2)} €</Text>
          </View>
        ))}

        {/* Totaux */}
        <View style={styles.totalSection}>
          {/*
          <View style={styles.totalRow}>
            <Text style={styles.totalLabel}>Sous-total</Text>
            <Text>{subtotal.toFixed(2)} €</Text>
          </View>
          */
          }
          <View style={styles.totalRow}>
            <Text style={styles.totalLabel}>Livraison</Text>
            <Text>{invoice.shipping} {invoice.devise}</Text>
          </View>
          {/*
          <View style={styles.totalRow}>
            <Text style={styles.totalLabel}>TVA (20%)</Text>
            <Text>{vat.toFixed(2)} €</Text>
          </View>*/
          }
          <View style={styles.totalLine}>
            <Text style={styles.totalBold}>Montant total</Text>
            <Text style={styles.totalBold}>{invoice.total} {invoice.devise}</Text>
          </View>
        </View>

        {/* Pied */}
        <View style={styles.footer}>
          <View>
            <Text style={styles.footerText}>Encaissé par : {invoice.collectedBy}</Text>
            <Text style={styles.footerText}>Merci pour votre achat !</Text>
          </View>
        </View>

      </Page>
    </Document>
  );
}

/*
export default function App() {
  return (
    <PDFDownloadLink
      document={<InvoiceDocument />}
      fileName="facture-INV-2024-00142.pdf"
    >
      {({ loading }) =>
        loading ? 'Génération...' : 'Télécharger la facture PDF'
      }
    </PDFDownloadLink>
  );
}
*/